<template>
  <SCASearchInput
    v-if="!isMini"
    :key="'search'"
    appearance="border"
    is-nav-bar-search
    :show-search-icon="true"
    :show-clear-icon="modelValue !== ''"
    show-shadow
    @clear="handleClear"
  >
    <input v-model="searchTerm" :placeholder="$t('common.action.search')" />
  </SCASearchInput>
  <SCADropdown
    v-else
    :offset-x="-9"
    :offset-y="8"
    placement="right-start"
    no-padding
    :trigger="isMini ? 'hover' : 'click'"
    shadow-variant="upward"
    no-mobile-margin
  >
    <template #trigger="{ target }">
      <SCAIconButton
        size="small"
        type="ghost"
        appearance="secondary"
        icon="phosphor/search"
        :popovertarget="target"
        :title="$t('common.action.search')"
      />
    </template>
    <template #default="{ popover }">
      <SidebarDropdownContainer>
        <template #header>
          <SidebarNavHeader
            v-model="localSearch"
            :is-mini="false"
            :show-settings="false"
            :search-active="!!localSearch"
            :set-all-expanded="props.setAllExpanded"
          />
        </template>
        <SidebarNavDefault :nodes="nodes ?? []" :search-term="localSearch" @close="popover?.hidePopover()" />
      </SidebarDropdownContainer>
    </template>
  </SCADropdown>
</template>

<script setup lang="ts">
import { SCADropdown, SCAIconButton, SCASearchInput } from "@scayla/components";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import type { NavNode } from "@/utils/navUtils";

import SidebarDropdownContainer from "./SidebarDropdownContainer.vue";
import SidebarNavDefault from "./SidebarNavDefault.vue";
import SidebarNavHeader from "./SidebarNavHeader.vue";

const { t: $t } = useI18n();

interface Props {
  modelValue: string;
  isMini: boolean;
  nodes?: NavNode[];
  setAllExpanded?: () => void;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  "update:modelValue": [value: string];
}>();

const searchTerm = computed({
  get: () => props.modelValue,
  set: (value: string) => emit("update:modelValue", value),
});

const handleClear = () => {
  emit("update:modelValue", "");
};

const localSearch = ref("");

defineExpose({ focus });
</script>
